import React from "react";
import { Navigate, useLocation } from "react-router-dom";

type Props = {
    to: string;
};

function NavigateWithRedirect({ to }: Props) {
    const location = useLocation();

    return (
        <Navigate
            to={{
                pathname: to,
                search: location.search
            }}
        />
    );
}

export default NavigateWithRedirect;
